import React, { useState, useEffect } from 'react'
import { Routes, Route, useNavigate } from 'react-router-dom'
import NavBar from './components/NavBar/NavBar'
import CreateProfile from './components/CreateProfile/CreateProfile'
import MyProfile from './components/MyProfile/MyProfile'
import Dashboard from './pages/Dashboard'
import MyPhotos from './pages/MyPhotos'
import PartnerPreferences from './components/PartnerPreferences/PartnerPreferences'
import NewMatches from './components/NewMatches/NewMatches'
import Settings from './pages/Settings/Settings'
import BasicSearch from './pages/Search/BasicSearch'
import AdvancedSearch from './pages/Search/AdvancedSearch'
import TodayMatches from './components/NewMatches/TodayMatches'
import ViewMatch from './components/NewMatches/ViewMatch'
import ViewProfile from './components/NewMatches/ViewProfile'
import EditPersonalProfile from './pages/EditPersonalProfile/EditPersonalProfile'
import Landing from './pages/LandingPage/Landing'
import PricingTable from './components/PricingTable/PricingTable'
import MyMatches from './components/NewMatches/MyMatches'
import NearMe from './components/NewMatches/NearMe'
import RecentlyViewed from './components/NewMatches/RecentlyViewed'
import { useCookies } from 'react-cookie'
import axios from 'axios'
import key from './key'
import { useDispatch } from 'react-redux'
import { setUser, onlineStatus } from './Redux/features/User/userSlice';
import HelpDesk from './pages/helpDesk/HelpDesk'
import RecentList from './components/NewMatches/ListContainers/RecentList'
import ShortListed from './components/NewMatches/ListContainers/ShortListed'
import IgnoredList from './components/NewMatches/ListContainers/IgnoredList'
import BlockedList from './components/NewMatches/ListContainers/BlockedList'
import ReceviedList from './components/NewMatches/ListContainers/ReceviedList'
import DeletedList from './components/NewMatches/ListContainers/DeletedList'
import AcceptedList from './components/NewMatches/ListContainers/AcceptedList'
import SentList from './components/NewMatches/ListContainers/SentList'
import ContactViewedList from './components/NewMatches/ListContainers/ContactViewedList'
import { PulseLoader } from 'react-spinners';
import ChatWidget from './components/ChatWidget/ChatWidget'
import VisitorsList from './components/NewMatches/ListContainers/VisitorsList'
import Footer from './components/Footer/Footer'
import PaymentSuccessPage from './pages/PaymentSuccess'
import ContactUs from './pages/ContactUs'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermAndConditions from './pages/TermAndConditions'
import AboutUs from './pages/AboutUs'

const App = () => {
  const [loading, setLoading] = useState(false)
  // eslint-disable-next-line
  const [cookies, setCookie, removeCookie] = useCookies(['x-auth-token', 'x-auth-registration'])
  let data = {
    header: cookies['x-auth-token'],
  }
  const [isLogged, setIsLogged] = useState("nologin")


  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true)
    const token = cookies['x-auth-token'];
    const registerToken = cookies['x-auth-registration'];

    const findMatches = async () => {
      await axios.get(`${key}/api/user/find-matches`, {
        headers: {
          'x-auth-token': cookies['x-auth-token']
        },
      }).then((response) => {
        dispatch(setUser(response.data.updatedUser));
        setLoading(false)
      }
      ).catch((error) => {
        console.log(error)
      })
    }
    const onlineStatusss = (value) => {
      let dataa = {
        status: value,
      }
      dispatch(onlineStatus({ ...data, dataa }));
    }
    const verifyToken = async () => {
      try {
        const response = await axios.get(`${key}/api/user/verify`, {
          headers: {
            'x-auth-token': token
          }
        })
        if (response.data.success) {
          setIsLogged("login");
          dispatch(setUser(response.data.user));
          findMatches();
          onlineStatusss(true);
          setLoading(false)
        } else {
          setIsLogged("nologin");
          navigate('/'); // Redirect to landing page if token verification fails
        }
      } catch (error) {
        console.log(error)
        setIsLogged("nologin");
        navigate('/'); // Redirect to landing page if an error occurs during token verification
      }
    };
    const verifyRegistrationToken = async () => {
      try {
        const response = await axios.get(`${key}/api/user/verify`, {
          headers: {
            'x-auth-token': registerToken
          }
        })
        if (response.data.success) {
          setIsLogged("register");
          navigate('/create-profile'); // Redirect to create profile page if token verification is successful
          setLoading(false)
        } else {
          navigate('/'); // Redirect to landing page if token verification fails
          setLoading(false)
        }
      } catch (error) {
        console.log(error)
        setIsLogged("nologin");
        navigate('/'); // Redirect to landing page if an error occurs during token verification
      }
    };


    if (registerToken) {
      verifyRegistrationToken();
    } else {
      if (token) {
        verifyToken();
      } else {
        setIsLogged("nologin");
        setLoading(false)
        navigate('/'); // Redirect to landing page if token is not present
      }
    }

    // const onlineStatus = () => {
    //   let data = {
    //     one: {
    //       status: false,
    //     },
    //     header: cookies['x-auth-token']
    //   }
    //   dispatch(onlineStatus(data));
    // }


    // eslint-disable-next-line
  }, [cookies]);
  return (
    <>
      {loading ? <div className="loading-spinner"><PulseLoader size={50} color="#fa585b" /></div> :
        <div style={{ backgroundColor: '#f1f1f2', height: 100 + '%' }}>
          {isLogged === "register" ? (<CreateProfile />) : isLogged === "nologin" ? (
            <Routes>
              <Route path='/' element={<Landing />} />
              <Route path='/contact-us' element={<ContactUs />} />
              <Route path='/about-us' element={<AboutUs />} />
              <Route path='/privacy-policy' element={<PrivacyPolicy />} />
              <Route path='/terms-conditions' element={<TermAndConditions />} />
            </Routes>
          ) : (<>
            <NavBar />
            <Routes>
              <Route path='/' element={<Dashboard />} />
              <Route path='/dashboard' element={<Dashboard />} />
              {/* <Route exact path='/create-profile' element={<CreateProfile />} /> */}
              <Route path='/myprofile' element={<MyProfile />} />
              <Route path='/myphotos' element={<MyPhotos />} />
              <Route path='/partnerPreferences' element={<PartnerPreferences />} />
              <Route path='/newmatches' element={<NewMatches />} />
              <Route path='/settings' element={<Settings />} />
              <Route path='/basicsearch' element={<BasicSearch />} />
              <Route path='/advancedsearch' element={<AdvancedSearch />} />
              <Route path='/todaysmatches' element={<TodayMatches />} />
              <Route path='/newmatches/view-match/:id' element={<ViewMatch />} />
              <Route path='/view-profile/:id' element={<ViewProfile />} />
              <Route path='/edit-personal-profile' element={<EditPersonalProfile />} />
              <Route path='/pricing-table' element={<PricingTable />} />
              <Route path='/matches' element={<MyMatches />} />
              <Route path='/view-match/:id' element={<ViewMatch />} />
              <Route path='/nearme' element={<NearMe />} />
              <Route path='/help-desk' element={<HelpDesk />} />
              <Route path='/recently-viewed' element={<RecentlyViewed />} >
                <Route path='recent' element={<RecentList title={"The Members you Recently Viewed"} />} />
                <Route path='shortlisted' element={<ShortListed title={"Shortlisted Members"} />} />
                <Route path='contact-viewed' element={<ContactViewedList title={"You Viewed Contact of these Members"} />} />
                <Route path='ignored' element={<IgnoredList title={"Ignored Members"} />} />
                <Route path='blocked' element={<BlockedList title={"Blocked Members"} />} />
                <Route path='recent-visitors' element={<VisitorsList title={"The Members Who Visited Your Profile"} />} />
              </Route>
              {/* <Route path='/morematches' element={<MoreMatches user={user} />} >
                <Route path='recentvisitors' element={<RecentVisitorList user={user} matches={recentVisitors} title={"Recent Visitors"} />} />
                <Route path='premiummatches' element={<PremiumList user={user} matches={premiumMatches} title={"Premium Matches"} />} />
                <Route path='maylike' element={<MayLikeList user={user} matches={mayLike} title={"Members that match your preferences"} />} />
              </Route> */}
              <Route path='/chat' element={<ChatWidget />} />
              <Route path='/received' element={<ReceviedList title={"All these Members Wants to Connect with you"} />} />
              <Route path='/sent' element={<SentList title={"You Sent the Invitation to these Members"} />} />
              <Route path='/accepted' element={<AcceptedList title={"You Accepted the Invitation of these Members"} />} />
              <Route path='/deleted' element={<DeletedList title={"Rejected/Deleted Members"} />} />
              <Route path='/payment-success' element={<PaymentSuccessPage />} />
              <Route path='/contact-us' element={<ContactUs />} />
              <Route path='/about-us' element={<AboutUs />} />
              <Route path='/privacy-policy' element={<PrivacyPolicy />} />
              <Route path='/terms-conditions' element={<TermAndConditions />} />
            </Routes>
          </>
          )}
          <Footer />
        </div>
      }
    </>
  )
}

export default App
